import {XMarkIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React, {FC, useCallback, useEffect, useState} from 'react';
import {DebounceInput} from 'react-debounce-input';

import {SearchIcon} from '../../../resources/Icons';
import Col from '../../common/Col';
import Row from '../../common/Row';
import ToggleButton from './buttons/ToggleButton';
import AdditionalInfo from './questions/AdditionalInfo';

type FilterType = {
  slug: string;
  label: string;
  toggled: boolean;
};

type PropsType = {
  searchValue: string | undefined;
  onSearchValueChange: (searchValue: string) => void;
  filters: FilterType[];
  onFilterToggled: (slug: string) => void;
  placeholder?: string;
  error?: string;
  info?: JSX.Element;
};

const ResourcesSearch: FC<PropsType> = ({
  searchValue,
  filters,
  onSearchValueChange,
  onFilterToggled,
  error,
  info,
  placeholder,
}) => {
  // Using an intermediate inputValue is necessary for
  // seeing inmediately the effects of clearing the input
  const [inputValue, setInputValue] = useState(searchValue || '');
  const clearInput = useCallback(() => {
    setInputValue('');
    onSearchValueChange('');
  }, [onSearchValueChange]);
  useEffect(() => {
    setInputValue(searchValue ?? '');
  }, [searchValue]);
  return (
    <Col className="relative justify-center">
      <SearchIcon
        className={classNames(
          'absolute top-[15px] m-auto ml-[12px] w-[20px] h-[20px]',
          !!searchValue && 'text-primary-300'
        )}
      />
      <DebounceInput
        className={classNames('text-left pl-[40px] text-sm h-[50px] mb-xs', !!searchValue && 'border-primary-300')}
        type={'text'}
        value={inputValue}
        onChange={event => onSearchValueChange(event.target.value)}
        placeholder={placeholder}
        debounceTimeout={600}
      />
      {!!searchValue && (
        <button
          onClick={clearInput}
          className="absolute top-[15px] right-[12px] w-[20px] h-[20px]"
          aria-label={'Clear'}
        >
          <XMarkIcon />
        </button>
      )}
      <Row className="gap-xs flex-wrap">
        {filters.map(({slug, label, toggled}) => (
          <ToggleButton key={slug} id={slug} label={label} onClick={slug => onFilterToggled(slug)} toggled={toggled} />
        ))}
      </Row>
      <AdditionalInfo error={error} info={info} />
    </Col>
  );
};

export default ResourcesSearch;
